<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-claim-product modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ค้นหาสินค้าสำหรับเคลม</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>วันที่สั่งจอง</label>
                                        <div class="input-component-range">
                                            <div class="input-component input-datepicker">
                                                <datepicker input-class="input-field"
                                                    calendar-class="gadget-datepicker-box"
                                                    placeholder="จาก"
                                                    format="d/M/yyyy"
                                                    v-model="formFilter.purchasedDateFrom">
                                                </datepicker>
                                                <b-icon icon="calendar2-minus"></b-icon>
                                            </div>
                                            <div class="input-component input-datepicker">
                                                <datepicker input-class="input-field"
                                                        calendar-class="gadget-datepicker-box"
                                                        placeholder="ถึง"
                                                        format="d/M/yyyy"
                                                        v-model="formFilter.purchasedDateTo">
                                                </datepicker>
                                                <b-icon icon="calendar2-minus"></b-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>พิมพ์ค้นหา</label>
                                        <input type="text" v-model="formFilter.keyword" class="input-field" placeholder="เลขที่บิล / ทะเบียนรถ / ชื่อลูกค้า" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="mt-3 text-center">
                                        <button class="btn btn-secondary" @click="loadPurchasedList()"><b-icon icon="search"></b-icon> ค้นหาประวัติการซื้อ</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

                        <div class="mt-3" v-if="isShowResult">
                            <template v-if="searchResult.length > 0">
                                <perfect-scrollbar>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>วันที่รับสินค้า</th>
                                                <th>เลขที่บิล</th>
                                                <th>สินค้าที่สั่งซื้อ</th>
                                                <th>ข้อมูลลูกค้า</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in searchResult" :key="index">
                                                <td>{{ item.purchaseDate }}</td>
                                                <td>{{ item.billNo }}</td>
                                                <td>
                                                    <span class="text-nowrap" v-if="item.sku">SKU: {{ item.sku }}</span>
                                                    {{ item.product }}
                                                    <span class="text-nowrap" v-if="item.dot">สัปดาห์ยาง: {{ item.dot }}</span>
                                                </td>
                                                <td>
                                                    {{ item.car }}
                                                    <br />
                                                    <span class="customer-name">{{ item.customer }}</span>
                                                </td>
                                                <td><div class="text-center"><button class="btn btn-sm btn-blue text-nowrap" @click="selectClaim(item.data)">เลือก</button></div></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>

                                <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="searchResult.length" class="mt-4"></paging>
                            </template>

                            <template v-if="searchResult.length === 0">
                                <div class="filter">
                                    <div class="no-data">
                                        <b-icon icon="exclamation-diamond"></b-icon>
                                        <span>ไม่พบรายการสั่งซื้อในระบบ โปรดทำการค้นหาใหม่อีกครั้ง</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import DBJob from '@/database/Job';

export default {
    data() {
        return {
            isActive: false,
            isShowResult: false,
            isLoading: false,
            formFilter: this.initPurchasedFilter(),
            searchResult: [],
            activePage: 1,
            pageSize: 10
        };
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);
        }
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        initPurchasedFilter() {
            return {
                keyword: '',
                purchaseDateFrom: '',
                purchaseDateTo: ''
            }
        },
        filterResult(result) {
            if (this.formFilter.keyword) {
                result = result.filter(x => x.number?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1 
                                        || x.purchaseItem.inventoryData.sku?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                        || x.purchaseItem.productData.name?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                        || x.customer.customerFirstName?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                        || x.customer.customerLastName?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                        || x.customer.customerTel?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1
                                        || x.customer.licensePlate?.toLowerCase().indexOf(this.formFilter.keyword.toLowerCase()) > -1);
            }
            if (this.formFilter.purchasedDateFrom) {
                const filterDate = this.formFilter.purchasedDateFrom;
                filterDate.setHours(0, 0, 0, 0);

                result = result.filter(x => x.closeDate.getTime() >= filterDate.getTime())
            }
            if (this.formFilter.purchasedDateTo) {
                const filterDate = this.formFilter.purchasedDateTo;
                filterDate.setHours(23, 59, 59, 0);

                result = result.filter(x => x.closeDate.getTime() <= filterDate.getTime())
            }

            return result;
        },
        async loadPurchasedList() {
            this.isShowResult = false;
            this.isLoading = true;
            this.searchResult = [];

            const result = await DBJob.get();

            if (result.content && result.content.length > 0) {
                // Generate New List
                let purchaseList = this.setupPurchaseList(result.content);

                // Filter Result
                purchaseList = this.filterResult(purchaseList);

                // Map and Place into the Object
                this.searchResult = this.mapViewData(purchaseList);
            }

            // Done Search
            this.isLoading = false;
            this.isShowResult = true;
        },
        setupPurchaseList(jobList) {
            const purchaseList = [];

            jobList.forEach((jobItem) => {
                if (jobItem.status === this.$Constants.JOB_STATUS_COMPLETE) {
                    jobItem.order.productList.forEach((purchaseItem) => {
                        if (purchaseList.filter(x => x.number === jobItem.number 
                                                && x.purchaseItem.inventoryKey === purchaseItem.inventoryKey
                                                && x.purchaseItem.input.dot === purchaseItem.input.dot)
                                        .length === 0) {
                            purchaseList.push({
                                number: jobItem.number,
                                closeDate: jobItem.closeDate,
                                customer: jobItem.customer,
                                purchaseItem: purchaseItem
                            });
                        }
                    });
                }
            });

            return purchaseList;
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    purchaseDate: this.$AppUtility.displayTimeFormat(item.closeDate),
                    billNo: item.number,
                    sku: item.purchaseItem.inventoryData.sku,
                    product: item.purchaseItem.productData.name,
                    dot: item.purchaseItem.input.dot,
                    car: [ item.customer.carBrand, item.customer.carModel, item.customer.carYearSerie ].filter(Boolean).join(' '),
                    customer: [ item.customer.customerFirstName, item.customer.customerLastName ].join(' '),
                    data: item
                });
            });

            return data;
        },
        selectClaim(item) {
            this.$emit('hide', item);
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-claim-product {
    max-width: 1000px;

    table {
        font-size: 13px;

        .customer-name {
            opacity: 0.6;
        }
    }
}
</style>